import React, { useEffect } from 'react';
import Routes from './Routes';
import Login from './pages/login/Login';
import OAuthLogin from './pages/oauth-login/OAuthLogin';
import AuthValidate from './pages/auth-validate/AuthValidate';
import CreatePassword from './pages/create-password/CreatePassword';
import PwaLogin from './pages/pwa-login/PwaLogin';
import PwaHome from './pages/pwa-home/PwaHome';
import PwaBondInsuranceAnalysis from './pages/pwa-bond-insurance/PwaBondInsuranceAnalysis';
import PwaPreAnalysisList from './pages/pwa-pre-analysis-list/PwaPreAnalysisList';
import PwaNewAnalysis from './pages/pwa-new-analysis';
import PwaFireInsuranceBudgetRedirect from './pages/pwa-fire-insurance-budget/Redirect';
import RecoveryPassword from './pages/recovery-password/RecoveryPassword';
import ProtectedRoute from './components/ProtectedRoute';
import { Redirect, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import PageMaintenance from './pages/MaintenancePage';
import FireInsuranceBudgetIframe from './pages/iframe/fire-insurance-budget';
import StandaloneChargePaymentPage from './pages/standalone-charge-payment';
import StandaloneKycPage from './pages/standalone-kyc';
import CreditoRealFireCalculator from './pages/credito-real-fire-calculator';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles';
import { initializeGA } from './services/analytics';
import { usePwaInstall, isPwa } from './utils/pwaUtils';

const App = () => {
  usePwaInstall();

  useEffect(() => {
    initializeGA();
    if (isPwa()) {
      console.log('Running in PWA mode');
      // Potential analytics event here
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <meta name="google" content="notranslate" />
      </Helmet>
      <Route path="/" exact component={Login} />
      <Route path="/login" component={OAuthLogin} />
      <Route path="/auth-validate" component={AuthValidate} />
      <Route path="/create-password" component={CreatePassword} />
      <Route path="/pwa/login" component={PwaLogin} />
      <ProtectedRoute path="/pwa/home" component={PwaHome} />
      <ProtectedRoute path="/pwa/bond-insurance-analysis" component={PwaBondInsuranceAnalysis} />
      <ProtectedRoute
        path="/pwa/fire-insurance-budget"
        component={PwaFireInsuranceBudgetRedirect}
      />
      <ProtectedRoute path="/pwa/pre-analyses" component={PwaPreAnalysisList} />
      <ProtectedRoute path="/pwa/new-analysis" component={PwaNewAnalysis} />
      <Route path="/recovery-password" component={RecoveryPassword} />
      <Route path={`/manutencao`} component={PageMaintenance} />
      <Route path="/iframe/fire-insurance-budget" component={FireInsuranceBudgetIframe} />
      <Route path="/credito-real/seguro-incendio/:state" component={CreditoRealFireCalculator} />
      <Route
        path="/credito-real/seguro-incendio"
        exact
        render={() => <Redirect to="/credito-real/seguro-incendio/rs" />}
      />
      <Route path="/cobranca/:token" component={StandaloneChargePaymentPage} />
      <Route path="/biometria/:token" component={StandaloneKycPage} />
      <ProtectedRoute path="/admin" component={Routes} />
    </ThemeProvider>
  );
};

export default App;
